module.exports = new __parcel__URL__("uber-grocery.09c27c5f.webp").toString();